import { ROUTES } from "../Routes/routes";
import GenericLayout from "./GenericLayout";

export default function CentralDesignerHubLayout() {
  const menu = [
    {
      key: ROUTES.CENTRAL.Designer.DESIGNER_DASHBOARD
      , label: "Dashboard", icon: "bi bi-speedometer"
      , iconImage: ''
    },
    {
      key: ROUTES.CENTRAL.Designer.DesignerReport
      , label: "Designer Report", icon: "bi-file-earmark-text-fill"
      , iconImage: ''
    },
    {
      key: ROUTES.CENTRAL.Designer.DesignerCompleteOrders,
      label: "Complete Order",
      icon: "bi-patch-check-fill",
      iconImage: ""
    },

  ];

  const menuGroups = [
    {
      title: "Master",
      icon: "bi-collection-fill",
      items: [
        {
          key: ROUTES.CENTRAL.Designer.Settings.officetimings,
          label: "Office Timings",
          icon: "bi bi-clock-fill",
          iconImage: ''
        }
      ]
    }
  ];
  // const masterMenu = [
  //   {
  //     key: ROUTES.CENTRAL.Designer.Settings.officetimings,
  //     label: "Office Timings",
  //     icon: "bi bi-clock-fill",
  //     iconImage: ''
  //   },
  // ];

  return (
    <GenericLayout
      menu={menu}
      menuGroups={menuGroups}
      titleLabel="Designer"
      profileRoute={ROUTES.CENTRAL.Designer.DESIGNER_PROFILE}
      showNotifications
      apiNotificationUrl={`${process.env.REACT_APP_API_BASE_URL}/ClinicDetails/GetClinicNotifications`}
    />
  );
}
